import { connect } from 'react-redux';

import { AppRouter } from './app-router/app-router.component';

export const AppRouterContainer = connect(
  (state) => ({}),
  () => ({})
)(AppRouter);
